module.exports = __webpack_public_path__ + "static/media/pride_logo.a008c9b1.jpg";